export class MascaraUtil {

  static mascaraDeCPF(v: string): string {
    if ( v ) {
      try {
        v = v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
        return v;
      }
      catch(e) {
        console.error('mascara-util, mascaraDeCPF', e.message);
        return v;
      }
    }
    
    return v;
  }

  static mascaraDeTelefone(v: string): string {
    if ( v ) {
      try {
        v = v.replace(/\D/g,""); //Remove tudo o que não é dígito
        v = v.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
        v = v.replace(/(\d)(\d{4})$/,"$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos

        return v;
      }
      catch(e) {
        console.error('mascara-util, mascaraDeTelefone', e.message);
        return v;
      }
    }
  }

  static mascaraDeCNPJ(v: string): string {
    if ( v ) {
      try {
        v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
        return v;
      }
      catch(e) {
        console.error('mascara-util, mascaraDeCNPJ', e.message);
        return v;
      }
    }
  }  

}